// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"065b5abc","536":"96af2dcc","606":"da09e5b5","610":"1113e9bf","649":"95cc0ae8","735":"c23cf3fc","798":"e63db7b3","838":"5f8383bc","952":"c730f37f"}[chunkId] + ".chunk.js";
};